import { render } from "./VersionsCreate.vue?vue&type=template&id=76c3df5d"
import script from "./VersionsCreate.vue?vue&type=script&lang=js"
export * from "./VersionsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__